import { render, staticRenderFns } from "./onlySign.vue?vue&type=template&id=1c6ae915&scoped=true&"
import script from "./onlySign.vue?vue&type=script&lang=js&"
export * from "./onlySign.vue?vue&type=script&lang=js&"
import style0 from "./onlySign.vue?vue&type=style&index=0&id=1c6ae915&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6ae915",
  null
  
)

export default component.exports